export default "__VITE_ASSET__BbOcos2Y__"